<template>
  <div>
    <PageAppBar>Chat</PageAppBar>
    <div v-if="!Object.keys(stateuser).length" class="page-content header-clear-small">
      Nothing to show here.
      <FooterBar></FooterBar>
    </div>

    <div v-else class="page-content header-clear-small">
      <p>Round Chat</p>
      <div v-if="!stateuser.rounds" class="alert"> You have not joined round project yet. </div>
      <router-link v-for="round in stateuser.rounds" :key="'trp'+round.id" :to="'/chat/rounds/'+round.round_id">
        <div class="card card-style mb-3">
          <div class="d-flex">
            <div class="pl-3 ml-2 align-self-center">
              <h1 class="pt-4">TRP {{round.round_id}}{{round.projects}}</h1>
              <p class="font-11 opacity-50 mt-n2 mb-4">For all your Payment Purchases</p>
            </div>
            <div class="ml-auto mr-4 align-self-center">
              <i class="fa fa-credit-card color-blue2-dark fa-3x mt-4 mb-4"></i>
            </div>
          </div>
        </div>
      </router-link>

      <p>Stand Chat</p>
      <div v-if="!stateuser.stands.length" class="alert"> You have not joined stand project yet. </div>
      <router-link v-else v-for="stand in stateuser.stands" :key="'tsp'+stand.id" :to="'/chat/stands/'+stand.stand.id">
        <div class="card card-style mb-3">
          <div class="d-flex">
            <div class="pl-3 ml-2 align-self-center">
              <h1 class="pt-4">TSP {{stand.stand.id}}</h1>
              <p class="font-11 opacity-50 mt-n2 mb-4">For all your Payment Purchases</p>
            </div>
            <div class="ml-auto mr-4 align-self-center">
              <i class="fa fa-credit-card color-blue2-dark fa-3x mt-4 mb-4"></i>
            </div>
          </div>
        </div>
      </router-link>

      <p>Investment Chat</p>
      <div v-if="!stateuser.investments.length" class="alert"> You have not joined investment project yet. </div>
      <router-link v-else v-for="investment in stateuser.investments" :key="'tip'+investment.investment_id" :to="'/chat/investments/'+investment.investment_id">
        <div class="card card-style mb-3">
          <div class="d-flex">
            <div class="pl-3 ml-2 align-self-center">
              <h1 class="pt-4">TIP {{investment.investment_id}}</h1>
              <p class="font-11 opacity-50 mt-n2 mb-4">For all your Payment Purchases</p>
            </div>
            <div class="ml-auto mr-4 align-self-center">
              <i class="fa fa-credit-card color-blue2-dark fa-3x mt-4 mb-4"></i>
            </div>
          </div>
        </div>
      </router-link>

      <p>Farming Chat</p>
      <div v-if="!stateuser.farming_projects.length" class="alert"> You have not joined farming project yet. </div>
      <router-link v-else v-for="project in stateuser.farming_projects" :key="'tfp'+project.id" :to="'/chat/projects/'+project.farming_id">
        <div class="card card-style mb-3">
          <div class="d-flex">
            <div class="pl-3 ml-2 align-self-center">
              <h1 class="pt-4">TFP {{project.farming_id}}</h1>
              <p class="font-11 opacity-50 mt-n2 mb-4">For all your Payment Purchases</p>
            </div>
            <div class="ml-auto mr-4 align-self-center">
              <i class="fa fa-credit-card color-blue2-dark fa-3x mt-4 mb-4"></i>
            </div>
          </div>
        </div>
      </router-link>
      <FooterBar></FooterBar>
    </div>
  </div>
</template>

<script>
import global from "@/mixins/global";
import PageAppBar from "../components/PageAppBar";
import FooterBar from "@/components/FooterBar";
export default {
  mixins: [global],
  mounted() {
    this.loadUser()
  },
  components: {FooterBar, PageAppBar},
  computed: {
    stateuser(){
      return this.$store.getters.user
    }
  }
}
</script>

<style>

</style>